export default "__VITE_ASSET__BwLpCRqX__"